import React, { useState } from "react";

import professions2025 from "@helpers/data/professionNeed.json";
import professions2026 from "@helpers/data/professionNeed2026.json";

import styles from "./styles/jobMarket.module.css";

const YEAR_TABS = [
  { year: 2026, items: professions2026 },
  { year: 2025, items: professions2025 },
];

function formatSalary(value) {
  if (!value) return null;
  return `${value} ₽`;
}

function ProfessionList({ items, year }) {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <ul className={styles.professionList}>
      {items.map((item) => {
        const isOpen = openId === item.id;
        const panelId = `profession-panel-${year}-${item.id}`;

        return (
          <li
            key={item.id}
            className={`${styles.professionItem} ${
              isOpen ? styles.professionItemOpen : ""
            }`}
          >
            <button
              type="button"
              className={styles.professionToggle}
              onClick={() => toggle(item.id)}
              aria-expanded={isOpen}
              aria-controls={panelId}
            >
              <span className={styles.professionDot} aria-hidden="true" />
              <span className={styles.professionName}>{item.profession}</span>
              <span
                className={`${styles.professionChevron} ${
                  isOpen ? styles.professionChevronOpen : ""
                }`}
                aria-hidden="true"
              />
            </button>

            <div
              id={panelId}
              className={`${styles.professionPanel} ${
                isOpen ? styles.professionPanelOpen : ""
              }`}
              role="region"
              aria-label={item.profession}
              aria-hidden={!isOpen}
            >
              <div className={styles.professionPanelInner}>
                <div className={styles.professionBlock}>
                  <div className={styles.professionBlockTitle}>Описание</div>
                  <p>{item.description}</p>
                </div>
                <div className={styles.professionBlock}>
                  <div className={styles.professionBlockTitle}>Требования</div>
                  <p>{item.needs}</p>
                </div>
                {(item.salary_middle || item.salary_max) && (
                  <div className={styles.professionSalary}>
                    {item.salary_middle ? (
                      <span>
                        Средняя:{" "}
                        <strong>{formatSalary(item.salary_middle)}</strong>
                      </span>
                    ) : null}
                    {item.salary_middle && item.salary_max ? (
                      <span className={styles.professionSalarySep}>·</span>
                    ) : null}
                    {item.salary_max ? (
                      <span>
                        Макс.: <strong>{formatSalary(item.salary_max)}</strong>
                      </span>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}

function ProfessionsAccordion() {
  const [activeYear, setActiveYear] = useState(2026);
  const activeTab = YEAR_TABS.find((tab) => tab.year === activeYear);

  return (
    <div className={styles.professions}>
      <p>
        Ниже — наиболее востребованные профессии на рынке труда. Нажмите на
        название, чтобы увидеть описание и требования к кандидату.
      </p>

      <div
        className={styles.yearTabs}
        role="tablist"
        aria-label="Год списка профессий"
      >
        {YEAR_TABS.map((tab, index) => {
          const isActive = tab.year === activeYear;
          const isStart = index === 0;
          const isEnd = index === YEAR_TABS.length - 1;

          return (
            <button
              key={tab.year}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`${styles.yearTab} ${
                isStart ? styles.yearTabStart : ""
              } ${isEnd ? styles.yearTabEnd : ""} ${
                isActive ? styles.yearTabActive : ""
              }`}
              onClick={() => setActiveYear(tab.year)}
            >
              {tab.year}
            </button>
          );
        })}
      </div>

      <ProfessionList
        key={activeYear}
        year={activeYear}
        items={activeTab.items}
      />
    </div>
  );
}

export default ProfessionsAccordion;
